// 'light' | 'auto' | 'dark'

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'))
  return match ? decodeURIComponent(match[1]) : null
}

function setSharedCookie(name, value) {
  document.cookie = `${name}=${encodeURIComponent(value)}; domain=.graspil.com; path=/; max-age=${365 * 24 * 3600}; SameSite=Lax`
}

function readThemeMode() {
  // localStorage = explicit choice on this domain; cookie = cross-subdomain sync for new sessions
  const local = localStorage.getItem('themeMode')
  if (local && ['light', 'dark', 'auto'].includes(local)) return local
  const cookie = getCookie('graspil_theme')
  if (cookie && ['light', 'dark', 'auto'].includes(cookie)) return cookie
  return 'auto'
}

const savedMode = readThemeMode()

function readSidebarCollapsed() {
  return localStorage.getItem('sidebarCollapsed') === 'true'
}

function systemPrefersDark() {
  return window.matchMedia('(prefers-color-scheme: dark)').matches
}

function resolveIsDark(mode) {
  if (mode === 'dark')  return true
  if (mode === 'light') return false
  return systemPrefersDark()
}

export default {
  namespaced: true,
  state: {
    loadingApp: true,
    // Лёгкий индикатор навигации между уже загруженными страницами (в отличие
    // от loadingApp — не блокирует экран, нужен в основном чтобы показать
    // прогресс догрузки lazy-чанка роута (report-builder и т.п.)
    routeLoading: false,
    hideConfigButton: false,
    isPinned: false,
    // персистится вручную (localStorage) через toggleSidebarCollapse; страницы вроде
    // конструктора воркфлоу могут временно форсировать через __set и вернуть на выходе
    sidebarCollapsed: readSidebarCollapsed(),
    showConfig: false,
    sidebarType: resolveIsDark(savedMode) ? "bg-default" : "bg-white",
    isRTL: false,
    mcolor: "",
    // themeMode — пользовательский выбор ('light' | 'auto' | 'dark')
    themeMode: savedMode,
    // darkMode — производное, только для чтения (используется в шаблонах)
    darkMode: resolveIsDark(savedMode),
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    layout: "default",
    isTransparent: "bg-transparent",
    breadcrumbs: "",
    h1: "",
    mobileSidebarOpen: false,
    mobileReportsPanelRequest: false
  },

  mutations: {
    /**
     * send object like: {name: 'breadcrumbs', val: this.$route.params.type_report}
     * Where name it is name property in state
     * @param state
     * @param name
     * @param val
     * @private
     */
    __set(state, {name, val}) {
      state[name] = val
    },
    setIsAbsolute(state, val) {
      state.isAbsolute = val
    },
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    navbarMinimize(state) {
      const sidenav_show = document.querySelector(".g-sidenav-show");

      if (!state.isPinned) {
        sidenav_show.classList.remove("g-sidenav-hidden");
        sidenav_show.classList.add("g-sidenav-pinned");
        state.isPinned = true;
      } else {
        sidenav_show.classList.add("g-sidenav-hidden");
        sidenav_show.classList.remove("g-sidenav-pinned");
        state.isPinned = false;
      }
    },
    navbarHidden(state) {
      const sidenav_show = document.querySelector(".g-sidenav-show");
      if (state.isPinned && !sidenav_show.classList.contains("g-sidenav-hidden")) {
        sidenav_show.classList.add("g-sidenav-hidden");
        sidenav_show.classList.remove("g-sidenav-pinned");
        state.isPinned = false;
      }
    },
    sidebarType(state, payload) {
      state.sidebarType = payload;
    },
    toggleSidebarCollapse(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed;
      localStorage.setItem('sidebarCollapsed', String(state.sidebarCollapsed));
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    },
    openMobileSidebar(state) {
      state.mobileSidebarOpen = true;
    },
    closeMobileSidebar(state) {
      state.mobileSidebarOpen = false;
    },
    toggleMobileSidebar(state) {
      state.mobileSidebarOpen = !state.mobileSidebarOpen;
    },
    openMobileSidebarWithReports(state) {
      state.mobileSidebarOpen = true;
      state.mobileReportsPanelRequest = true;
    },
    clearMobileReportsPanelRequest(state) {
      state.mobileReportsPanelRequest = false;
    },

    // Устанавливает режим ('light' | 'auto' | 'dark') и обновляет производный darkMode
    setThemeMode(state, mode) {
      state.themeMode = mode
      state.darkMode  = resolveIsDark(mode)
      state.sidebarType = state.darkMode ? "bg-default" : "bg-white"
      localStorage.setItem('themeMode', mode)
      setSharedCookie('graspil_theme', mode)
      // Убираем старый ключ чтобы не мешал
      localStorage.removeItem('darkMode')
    },

    // Вызывается из App.vue когда меняется системная тема (только при mode === 'auto')
    applySystemTheme(state) {
      if (state.themeMode === 'auto') {
        state.darkMode    = systemPrefersDark()
        state.sidebarType = state.darkMode ? "bg-default" : "bg-white"
      }
    }
  },

  actions: {
    toggleSidebarColor({ commit }, payload) {
      commit("sidebarType", payload);
    }
  },

  getters: {}
}
